import { render } from "./DashboardCertificate.vue?vue&type=template&id=56d3630a&scoped=true&ts=true"
import script from "./DashboardCertificate.vue?vue&type=script&lang=ts"
export * from "./DashboardCertificate.vue?vue&type=script&lang=ts"

import "./DashboardCertificate.vue?vue&type=style&index=0&id=56d3630a&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d3630a"]])

export default __exports__